import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';
import { DirectService, FullTemplate } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  selector: 'sbnb-direct-add-template',
  templateUrl: './direct-add-template.component.html',
})
export class DirectAddTemplateComponent implements OnInit {
  templates: FullTemplate[] = [];
  originalTemplateId: string;
  selectedTemplateId: string;
  iframeSrc: SafeResourceUrl;
  loading = false;

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    private direct: DirectService,
    private directAddService: DirectAddService,
    private sanitizer: DomSanitizer,
    private deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit(): void {
    this.direct.getSiteTemplates().subscribe((templates) => {
      this.templates = templates;

      this.switchTemplate(this.directAddService.site.template);
      this.originalTemplateId = this.directAddService.site.template;
    });
  }

  switchTemplate(templateId: string) {
    this.selectedTemplateId = templateId;
    const template = this.templates.find((t) => Number(t.id) === Number(templateId));
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(template.preview_url);
  }

  getTemplates() {
    this.direct.getSiteTemplates().subscribe((templates) => {
      this.templates = templates;
    });
  }

  updateSiteTemplate() {
    if (this.originalTemplateId && this.selectedTemplateId !== this.originalTemplateId) {
      this.loading = true;
      this.direct.switchSiteTemplate(this.directAddService.site.id, this.selectedTemplateId).subscribe(
        () => {
          this.directAddService.site = {
            ...this.directAddService.site,
            template: this.selectedTemplateId,
          };
          this.directAddService.nextStep();
        },
        () => (this.loading = false)
      );
    } else {
      this.directAddService.nextStep();
    }
  }

  skip() {
    this.directAddService.nextStep();
  }
}
